import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang, UI } from "@/i18n/lang";

const KEY = "wv_cookie_consent";

// Wire the consent choice to PostHog analytics (loaded in index.html).
const applyConsent = (choice) => {
  try {
    if (window.posthog) {
      if (choice === "accepted") window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) {
    /* analytics not ready */
  }
};

export default function CookieBanner() {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = localStorage.getItem(KEY);
    } catch (e) {
      /* localStorage unavailable */
    }
    if (stored) applyConsent(stored);
    else setShow(true);
  }, []);

  const choose = (choice) => {
    try {
      localStorage.setItem(KEY, choice);
    } catch (e) {
      /* ignore */
    }
    applyConsent(choice);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="cookie-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.45, ease: [0.33, 1, 0.68, 1] }}
          className="fixed bottom-4 left-4 z-[55] max-w-[calc(100%-7rem)] sm:max-w-md rounded-xl border border-border bg-secondary/95 backdrop-blur-xl p-5 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.7)]"
        >
          <p className="text-sm text-ink/80 leading-relaxed">
            {t(UI.cookie.text)}{" "}
            <Link to="/datenschutz" data-testid="cookie-more" className="text-bronze underline underline-offset-2 hover:text-[#f0be6e] transition-colors">
              {t(UI.cookie.more)}
            </Link>
          </p>
          <div className="mt-4 flex items-center gap-3">
            <button
              data-testid="cookie-accept"
              onClick={() => choose("accepted")}
              className="rounded-full bg-bronze text-paper px-6 py-2.5 text-[13px] font-semibold hover:bg-[#f0be6e] transition-colors duration-300"
            >
              {t(UI.cookie.accept)}
            </button>
            <button
              data-testid="cookie-reject"
              onClick={() => choose("rejected")}
              className="rounded-full border border-border px-6 py-2.5 text-[13px] font-medium text-stone hover:text-ink hover:border-ink transition-colors duration-300"
            >
              {t(UI.cookie.reject)}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
